import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IOrganization, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromOrganization from './state/organization.selectors';
import * as OrganizationAction from './state/organization.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, Subscription, skipWhile } from 'rxjs';


@Component({
    selector: 'organization-screen',
    templateUrl: 'organization.component.html',
    styleUrls: ['organization.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrganizationExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IOrganization | null>;
    stateDataSubscription: Subscription;
    stateData: IOrganization | null;

    getData: string = 'ORG';

    orgCCDetails = [];
    orgCIDetails = [];
    orgPPDetails = [];
    isNullOrgDetails: boolean = false;
    isLoadingOrgDetails: boolean = false;
    showErrorOrgDetails: boolean = false;
    errorMessageOrgDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['code', 'description'];
    // dataSource: MatTableDataSource<any>;


    constructor(
        private store: Store<fromOrganization.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }


    ngOnInit() {
        this.startSubscriptions();
        this.getActiveOrgDataCC();
        // this.getActiveOrgDataCI();
        // this.getActiveOrgDataPFTP();

    }
    onTabChange(val) {
        if (val === 1 && this.orgCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveOrgDataCI();
        } else if (val === 2 && this.orgPPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveOrgDataPFTP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }
    getActiveOrgDataCC() {
        this.isLoadingOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.orgCCDetails = data;
                        this.isLoadingOrgDetails = false;
                        // console.log('selected org list CC');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullOrgDetails = true;
                        this.errorMessageOrgDetails = 'There is not any selected org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorOrgDetails = true;
                    this.errorMessageOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveOrgDataCI() {
        this.isLoadingOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.orgCIDetails = data;
                        this.isLoadingOrgDetails = false;
                        // console.log('selected org list CI');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullOrgDetails = true;
                        this.errorMessageOrgDetails = 'There is not any selected org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorOrgDetails = true;
                    this.errorMessageOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveOrgDataPFTP() {
        this.isLoadingOrgDetails = true;
        this._dataService.AccDistInfo_GetActiveByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    if (data) {
                        this.orgPPDetails = data;
                        this.isLoadingOrgDetails = false;
                        // console.log('selected org list PFTP');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullOrgDetails = true;
                        this.errorMessageOrgDetails = 'There is not any selected org';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingOrgDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorOrgDetails = true;
                    this.errorMessageOrgDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    editOrgListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CC'])
            .subscribe({
                next: data => {
                    // console.log('org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Org (CC)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected org CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveOrgDataCC();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editOrgListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'CI'])
            .subscribe({
                next: data => {
                    // console.log('org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Org (CI)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected org CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveOrgDataCI();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editOrgListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.AccDistInfo_GetByName([this.getData, 'PP'])
            .subscribe({
                next: data => {
                    // console.log('org list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showAccDistDetails('Org (PFTP)', '', data);
                    this.ams.accDist.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected org PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.AccDistInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveOrgDataPFTP();
                                            this.ref.markForCheck();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromOrganization.getOrganizationScreenPending);
        this.stateData$ = this.store.select(fromOrganization.getOrganizationState);
        this.error$ = this.store.select(fromOrganization.getOrganizationScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new OrganizationAction.OrganizationScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}